import { render, staticRenderFns } from "./Assembly.vue?vue&type=template&id=e77bfbe8&"
import script from "./Assembly.vue?vue&type=script&lang=js&"
export * from "./Assembly.vue?vue&type=script&lang=js&"
import style0 from "./Assembly.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports